import React, { createContext, useState } from 'react';

export const TrailContext = createContext();

export default function TrailProvider(props) {

    const [trails, setTrails] = useState([
        {
          url: 'threestage',
          name: 'Threestage',
        },
        {
          url: 'duntroon',
          name: 'Duntroon Highlands',
          lastItem: true,
        }
      ])

    return(
        <TrailContext.Provider value={[trails, setTrails]}>
            {props.children}
        </TrailContext.Provider>
    )
}